import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { forkJoin, of } from 'rxjs';
import { mergeMap, map, catchError, filter, withLatestFrom, tap } from 'rxjs/operators';
import * as UiActions from '../actions/ui.actions';

@Injectable()
export class UiEffects {
    constructor(private actions$: Actions, private router: Router) { }
    
    closeSideModal$ = createEffect(() => this.actions$.pipe(
        ofType(UiActions.closeSideModal),
        tap(() => {
            this.router.navigate([{ outlets: { modal: null } }], {
                relativeTo: this.router.routerState.root.firstChild,
                queryParamsHandling: 'preserve',
            });
        })
    ), { dispatch: false });
}
